import { setCustomerDeviceTypeAction as setCustomerDeviceTypeOperation } from 'editor/src/store/app/slice';

export default setCustomerDeviceTypeOperation;
